import { api } from "../apiCore";

export function getEquipmentsList(company_id, include_data) {
    let url = `/bewhere/companies/${company_id}/trackers/list`;

    if (include_data) {
        url += `?include_data=${include_data}`;
    }

    return api.get(url)
}

export function getEquipmentsOfGroup(data) {
    const url = `/bewhere/groups/${data.groupId}/trackers`;

    return api.get(url)
}

export function addEquipmentToGroup(groupId , beacon_id){
    const url = `/bewhere/groups/${groupId}/trackers/${beacon_id}`;

    return api.putForm(url);
}

export function removeEquipmentFromGroup(groupId , beacon_id){
    const url = `/bewhere/groups/${groupId}/trackers/${beacon_id}`;

    return api.delete(url);
}

export function getEquipmentDates(beacon_id) {
    const url = `/bewhere/trackers/${beacon_id}/get_dates`;

    return api.get(url)
}

export function getEquipmentMetaData(data) {
    const url = `/bewhere/trackers/${data.beacon_id}/metadata?date=${data.date}`;

    return api.get(url);
}

